export const initialState = {
  items: [],
  isLoading: false
}

export default function (state = initialState, action) {
  // eslint-disable-next-line
  const { payload, type } = action

  switch (type) {
    case "SHOP_ORDER_ACTIVITY_ITEMS_SET_LOADING":
      return {
        ...state,
        isLoading: true
      }
    case "SHOP_ORDER_ACTIVITY_ITEMS_UNSET_LOADING":
      return {
        ...state,
        isLoading: false
      }
    case "SHOP_ORDER_ACTIVITY_ITEMS_LOAD_SUCCEEDED":
      return {
        ...state,
        items: payload.items || []
      }
    default:
      return state
  }
}
